<div style="display: flex; height: 100%;">
    <app-aside-edit (onDrag)="onDrag($event)"></app-aside-edit>
    <div style="height: 100%;; width: calc(100% - 300px); text-align: center; position: relative;">
        <div #fakeDrop class="fake-drop" [ngClass]="{'d-none': notDrag}" (drop)="onDrop($event)" (dragover)="dragOver($event)" (dragleave)="onDragLeave($event)">
        </div>
        <iframe style="height: 100%; width: 100%; border: 0" src='/'></iframe>
    </div>
</div>